
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/editorView/bodyStylesSetter.scss.css.virtualfile';
        module.exports = {};